/* ═══════════════════════════════════════════════════════════════
   FL QUIZ CONFIG — pas hier de inhoud aan
   Bestand: assets/fl-quiz-config.js

   Vragen toevoegen/wijzigen? Bewerk ALLEEN dit bestand.
   De quiz-engine (sections/fl-quiz.liquid) hoeft NOOIT
   aangepast te worden voor content-wijzigingen.
   ═══════════════════════════════════════════════════════════════ */

window.QUIZ_CONFIG = {

  /* ─── INTROSCHERM ────────────────────────────────────────────── */
  intro: {
    badge:    "persoonlijk vachtadvies",
    heading:  "wat heeft de vacht van jouw hond nodig?",
    body:     "Beantwoord 6 vragen en ontdek welke producten écht passen bij de vacht en huid van jouw hond.",
    cta:      "start de quiz",
    meta:     "6 vragen · 2 minuten"
  },

  /* ─── VRAGEN ──────────────────────────────────────────────────── */
  questions: [
    {
      id:   "v1",
      text: "wat voor type vacht heeft jouw hond?",
      options: [
        { text: "krul / doodle / poedel",       tags: ["antiklit"] },
        { text: "kort / gladhaar",               tags: ["signature"] },
        { text: "lang / halflang",               tags: ["antiklit"] },
        { text: "dubbele vacht / onderwol",      tags: ["antiklit"] }
      ]
    },
    {
      id:   "v2",
      text: "wat is de huidige staat van de vacht?",
      options: [
        { text: "droog — dof en/of touwig",           tags: ["signature"] },
        { text: "snel vet of zwaar",                  tags: ["pure"] },
        { text: "schilfers en/of constante jeuk",     tags: ["pure"] },
        { text: "normaal — glanzend en soepel",       tags: ["signature"] }
      ]
    },
    {
      id:   "v3",
      text: "hoe voelt de vacht aan direct na een wasbeurt?",
      options: [
        { text: "super zacht & gehydrateerd",     tags: ["signature"] },
        { text: "een beetje droog en touwig",      tags: ["pure"] },
        { text: "erg droog / gestript / stug",     tags: ["pure"], hardOverride: false }
      ]
    },
    {
      id:   "v4",
      text: "hoe ziet de huid van jouw hond eronder uit?",
      insertTruthBombAfter: true,
      options: [
        { text: "mooi roze & rustig — geen irritatie",          tags: ["signature"] },
        { text: "licht geïrriteerd / vlekjes",                  tags: ["pure"] },
        { text: "rood / vurig / schilfers / constante jeuk",    tags: ["pure"], hardOverride: true }
      ]
    },
    {
      id:   "v5",
      text: "wat is jouw grootste dagelijkse frustratie met de vacht?",
      options: [
        { text: "hardnekkige klitten / vilt",              tags: ["antiklit"] },
        { text: "'natte hond' geur / stank",               tags: ["geur"] },
        { text: "bruine speeksel- of traanvlekken",        tags: ["vlekken"] },
        { text: "onrust / krabben / bijten",               tags: ["pure"] }
      ]
    },
    {
      id:   "v6",
      text: "hoe vaak wordt jouw hond gewassen of geborsteld?",
      options: [
        { text: "wekelijks wassen met shampoo",        tags: ["signature"] },
        { text: "1× per maand / alleen bij vuil",      tags: ["signature"] },
        { text: "vaak borstelen / zelden wassen",      tags: ["dry"] },
        { text: "gebruik van waterblazer / föhn",      tags: ["antiklit"] }
      ]
    }
  ],

  /* ─── TUSSENSTUK (TRUTH BOMB) ────────────────────────────────── */
  truthBomb: {
    label:   "wist je dat...",
    stat:    "80%",
    heading: "van de honden krijgt jeuk door industriële sulfaten en siliconen in hun shampoo",
    body:    "De meeste shampoos bevatten agressieve wasmiddelen die de huidbarrière verstoren — ook als de huid er nu rustig uitziet. Tijd voor ontmaskering.",
    cta:     "ik ben benieuwd →"
  },

  /* ─── RESULTATEN ─────────────────────────────────────────────── */
  results: {
    antiklit: {
      badge:       "anti-klit advies",
      heading:     "de vacht van jouw hond heeft anti-klit verzorging nodig",
      body:        "De vacht van jouw hond is gevoelig voor klitten en vervilting — vervelend en pijnlijk. Met de juiste dagelijkse routine voorkom je klitten en houd je de vacht soepel, glanzend en gezond.",
      blockTitle:  "jouw dagelijkse routine",
      productKeys: ["coatSpray", "detanglingCream", "dryShampoo"],
      cta: {
        primary:   { text: "bekijk de anti-klit lijn",   url: "/collections/pure-hypo" },
        secondary: { text: "bekijk alle producten",       url: "/collections/verzorgingsproducten" }
      }
    },
    pure: {
      badge:       "hypoallergeen advies",
      heading:     "de huid en vacht van jouw hond vragen om rust",
      body:        "De huid van jouw hond heeft behoefte aan mildheid. Gebruik (tijdelijk) de hypoallergene Pure lijn — zonder sulfaten, siliconen of geurstoffen. Wil je toch een fijne geur? Voeg daarna de Dry Shampoo & Conditioner toe als afronding.",
      blockTitle:  "jouw dagelijkse routine",
      productKeys: ["pureShampoo", "pureConditioner", "dryShampoo"],
      cta: {
        primary:   { text: "bekijk de pure hypo lijn",   url: "/collections/pure-hypo" },
        secondary: { text: "bekijk alle producten",       url: "/collections/verzorgingsproducten" }
      }
    },
    mixed: {
      badge:       "combi-advies",
      heading:     "jouw hond profiteert van beide lijnen",
      body:        "De vacht en huid zijn in goede conditie, maar hebben extra zorg nodig. Met zowel de Signature lijn als de hypoallergene Pure lijn zullen huid en vacht verder verbeteren.",
      blocks: [
        { title: "geurlijn voor dagelijks gebruik",  productKeys: ["signatureShampoo", "signatureConditioner"] },
        { title: "pure lijn voor extra mildheid",    productKeys: ["pureShampoo", "pureConditioner"] }
      ],
      cta: {
        primary:   { text: "bekijk alle verzorgingsproducten", url: "/collections/verzorgingsproducten" },
        secondary: { text: "bekijk de signature lijn",         url: "/collections/signature" }
      }
    },
    signature: {
      badge:       "topconditie",
      heading:     "de vacht van jouw hond is in topconditie",
      body:        "Jouw borstel- en wasritueel werkt super! Wil je een fijne geur toevoegen? Kies dan voor onze Signature lijn. Ga je liever voor geurloos en extra zacht? Dan is de hypoallergene Pure lijn perfect.",
      blockTitle:  "jouw dagelijkse routine",
      productKeys: ["signatureShampoo", "signatureConditioner", "dryShampoo"],
      cta: {
        primary:   { text: "bekijk de signature lijn",   url: "/collections/signature" },
        secondary: { text: "of kies de pure hypo lijn",  url: "/collections/pure-hypo" }
      }
    },

    /* extra blokken */
    extras: {
      vlekken: {
        title:      "aanvulling — bruine vlekken",
        body:       "Oxidatie is onomkeerbaar: zodra traan- en speekselvocht in de haarschubben dringt, verkleurt de vacht definitief naar roestbruin. Alleen een dagelijkse neutralisatie-routine voorkomt dat nieuwe ijzerresten inbranden.",
        productKeys: ["cleanser"]
      },
      geur: {
        title:      "aanvulling — geur & frisheid",
        body:       "Wil jij genieten van een heerlijk frisse knuffel met je hond — en voortaan instappen in een auto zonder hondengeur? Onze anti-geur combinatie neutraliseert geuren direct aan de bron.",
        productKeys: ["antiSmell", "carPillow"]
      }
    }
  },

  /* ─── PRODUCTEN ───────────────────────────────────────────────── */
  products: {
    coatSpray: {
      icon: "🫧",
      name: "Coat Spray",
      desc: "Ontkit, verzacht en beschermt de vacht dagelijks. Ideaal tussendoor.",
      line: "anti-klit lijn",
      url:  "/products/coat-spray"
    },
    detanglingCream: {
      icon: "💧",
      name: "Detangling Cream",
      desc: "Werkt klitten los zonder pijn. Bevat geen siliconen of sulfaten.",
      line: "anti-klit lijn",
      url:  "/products/detangling-cream"
    },
    dryShampoo: {
      icon: "✨",
      name: "Dry Shampoo & Conditioner",
      desc: "Frist op zonder water. Licht geurend en verzachtend.",
      line: "signature lijn",
      url:  "/collections/droogshampoo-conditioner-spray"
    },
    pureShampoo: {
      icon: "🌿",
      name: "Hypoallergene Shampoo",
      desc: "Hypoallergeen en parfumvrij — voor de gevoelige huid en vacht.",
      line: "pure lijn",
      url:  "/products/hypoallergene-shampoo"
    },
    pureConditioner: {
      icon: "🌿",
      name: "Hypoallergene Conditioner",
      desc: "Kalmeert en herstelt de huidbarrière. Geen geurstoffen.",
      line: "pure lijn",
      url:  "/products/hypoallergene-conditioner"
    },
    signatureShampoo: {
      icon: "🌸",
      name: "Signature Shampoo",
      desc: "Verzorgt, glanst en geurt subtiel fris. Voor de dagelijkse wasroutine.",
      line: "signature lijn",
      url:  "/collections/signature-shampoo"
    },
    signatureConditioner: {
      icon: "🌸",
      name: "Signature Conditioner",
      desc: "Diep hydraterende conditioner met een lichte, frisse geur.",
      line: "signature lijn",
      url:  "/collections/signature-conditioner"
    },
    antiSmell: {
      icon: "🌬️",
      name: "Anti-Smell Spray",
      desc: "Neutraliseert hondenlucht direct aan de bron — niet maskeren, elimineren.",
      line: "verzorging",
      url:  "/collections/anti-smell-spray"
    },
    carPillow: {
      icon: "🚗",
      name: "Car & Pillow Spray",
      desc: "Voor auto, bank en kussen — zodat jij overal fris thuiskomt.",
      line: "verzorging",
      url:  "/collections/car-pillow-spray"
    },
    cleanser: {
      icon: "🐾",
      name: "Face Cleanser",
      desc: "Neutraliseert dagelijks de ijzerresten van traan- en speekselvlekken.",
      line: "verzorging",
      url:  "/collections/face-cleanser"
    }
  },

  /* ─── GLOBALE CTA KNOPPEN (fallback) ───────────────────────── */
  resultCTAs: {
    primary:   { text: "bekijk alle producten",  url: "/collections/verzorgingsproducten" },
    secondary: { text: "meer over de lijnen",    url: "/collections/verzorgingsproducten" }
  }

}; /* einde QUIZ_CONFIG */